/*
 * @Author: Zhouqi
 * @Date: 2025-10-29 17:19:50
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-11-19 10:30:46
 */
// 非hooks的方式，使用国际化
import { createIntl, createIntlCache, IntlShape } from 'react-intl';

import en from '@/lang/en.json';
import zh from '@/lang/zh.json';

// 定义支持的语言
const messages: Record<string, Record<string, string>> = {
  zh: zh as Record<string, string>,
  en: en as Record<string, string>,
};

const cache = createIntlCache();

// 创建一个函数来获取Intl对象
const getIntl = (locale: 'zh' | 'en'): IntlShape => {
  return createIntl(
    {
      locale,
      messages: messages[locale],
    },
    cache,
  );
};

// 创建一个帮助函数来获取翻译字符串
export const t = (id: string, values?: Record<string, any>) => {
  const locale =
    typeof navigator !== 'undefined' && navigator.language?.startsWith('zh')
      ? 'zh'
      : 'en';
  const intl = getIntl(locale);
  return intl.formatMessage({ id }, values);
};
